module.exports = __webpack_public_path__ + "img/empty-folder-icon.74fddf01.svg";